import { z } from 'zod';
/** Normalized layer occupancy from LS-1000 RGNTAGN / RGNTAGS (stored in Valkey). */
export const LayerOccupancySnapshotSchema = z.object({
    scopeType: z.literal('layer'),
    scopeId: z.string().min(1),
    /** Attested tag count (subset of engine roster). Engine total may be in totalCount. */
    tagCount: z.number().int().nonnegative(),
    /** Attested Cnapse serial numbers only (subset of engine roster). */
    locationDeviceIds: z.array(z.string().min(1)),
    /** Gateway receive time (ISO 8601 UTC). */
    lastSeenAt: z.string().datetime(),
    complete: z.boolean(),
    sourceMessages: z.array(z.string().min(1)).min(1),
    recordCount: z.number().int().nonnegative().optional(),
    totalCount: z.number().int().nonnegative().optional(),
    gatewaySerial: z.string().min(1).nullable().optional(),
});
export function parseLayerOccupancyPk(pk) {
    const idx = pk.indexOf('#');
    if (idx <= 0 || idx >= pk.length - 1)
        return null;
    return { tenantId: pk.slice(0, idx), siteId: pk.slice(idx + 1) };
}
//# sourceMappingURL=location-layer-occupancy.schema.js.map